var exports = {
  "i": "x127c5a35--3c62c3--wrapper",
  "k": "x127c5a35--3c62c3--container",
};

module.exports = exports;
